import { PermissionName } from '@sironamedical/common/constants/permissionName';
import { useValidateUserHasRbacPermissions } from 'hooks/useValidateUserHasRbacPermissions';

export const useBypassPrelimEnabled = (): boolean => {
  return useValidateUserHasRbacPermissions({
    permissionNames: [PermissionName.AllowBypassPrelimCountdown],
  });
};
